<script>
  import main from './Dialog.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './Dialog.scss'
</style>



// WEBPACK FOOTER //
// Dialog.vue?46f21ace